import { Helmet } from "react-helmet";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import View from "../components/View";
import { APP_NAME } from "../constants";
import toast from "react-hot-toast";
import { Card, Input } from "@rigly/core";
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline'
import { useAuthContext } from "../context/AuthContext";

export default function GSheet() {
  const { team } = useAuthContext()

  const gSheetURL = team?.gsheet_url || ''
  const handleCopyURL = () => {
    navigator.clipboard.writeText(gSheetURL)
    toast.success('Google Sheets link copied to clipboard!')
  }

  return (
    <div className="flex flex-col">
      <Helmet>
        <title>{APP_NAME} - Proxies</title>
      </Helmet>
      <Topbar />
      <div className="grid grid-cols-[200px_1fr] min-h-screen-excluding-topbar">
          <View>
            <Sidebar />
            <div className="p-3">
              <Card className="pt-2 p-4 items-start bg-radial-gradient-dark dark:bg-radial-gradient-light before:relative space-y-3">
                <div className="p-3 w-full flex flex-col lg:h-full gap-4">
                  <div className="flex items-center gap-2 w-full">
                    <Input
                      id="gsheet-url"
                      type="text" 
                      value={gSheetURL}
                    />
                    <button
                      type="button"
                      onClick={handleCopyURL}
                      className="flex items-center justify-center p-2 text-gray-500 hover:text-primary transition-colors"
                      title="Copy Google Sheets link"
                    >
                      <ClipboardDocumentIcon className="h-5 w-5" />
                    </button>
                  </div>
                </div>
              </Card>
            </div>
          </View>
      </div>
    </div>
  )
}
